import { RoutingPath } from 'mbs-ui-shared@constants';

// Exclude url for SleekPlan and Zoho widgets
export const excludedWidgetsUrls = [
  RoutingPath.ApConnectWiseNew,
  RoutingPath.ApEmailService,
  RoutingPath.ApGettingStart,
  RoutingPath.ApGlobalAgentOptions,
  RoutingPath.ApHaloPSA,
  RoutingPath.ApTicketSettings,
  RoutingPath.ApNotifications,
  RoutingPath.ApPlanReportSettings,
  RoutingPath.ApNewBackupHistory
];
